import { connect } from "react-redux";
import { createCampaign } from "../../../../store/action/campaignsAction";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../routers/constants";

const NoCampaign = (props) => {
   const { createCampaign } = props;
   const navigate = useNavigate();

   return (
      <div className="livestream-intro hint-intro sale-post-intro">
         <div className="wrapper">
            <div className="left">
               <label className="title">Livestream bán hàng và chốt đơn hiệu quả</label>
               <p className="description">Gia tăng hiệu suất bán hàng, tự động chốt đơn theo Từ khóa sản phẩm</p>
               <div className="action">
                  <Link to={URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_DEFAULT_SETTINGS}>
                     <button type="button" className="app-btn app-btn-primary button-add">
                        <div className="svg-next-icon mr8 ic-plus-2">
                        </div>
                        Tạo kịch bản
                     </button>
                  </Link>
               </div>
            </div>
            <div className="right">
               <div className="svg-next-icon icon-sale-post-intro">
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = () => {
   return {

   };
};

export default connect(mapStateToProps, {
   createCampaign
})(NoCampaign)
